<template>
    <v-container fluid>
    <tracking-skeleton :saving="saving" @save="save" @copyOpen="copyOpen" @mailOpen="mailOpen" v-model="open"  :fails.sync="fails" :platform="platform" :platformSettings="platformSettings">
        <template v-slot:tracker="{id}">
            <p id="instructions-tracker" v-html="$t('tracking.other.tracker[0]')"></p>
            <code-block language="html" :code="code.tracker.replace('%id%', id)" />
        </template>
    </tracking-skeleton>
    </v-container>
</template>
<script>

import TrackingSkeleton from '@/components/TrackingSkeleton'
import CodeBlock from '@/components/CodeBlock'
import EntityForm from '@/mixins/entity-form'
import Wizards from '@/mixins/wizards'
import PanelOpener from "@/mixins/panel-opener"
import {mapGetters} from "vuex"

export default {
    name: 'TrackingShoptet',
    components: { TrackingSkeleton, CodeBlock  },
    mixins: [EntityForm, Wizards, PanelOpener ],
    data() {
        return {
            endpoint: 'domains',
            fields: {
            },
            panels: ['tracker'],
            platform: 'SHOPTET'
        }
    },
    computed: {
        platformSettings() {
            return this.$store.getters['domains/platformSettings'](this.platform)
        },
        ...mapGetters('ui', ['baseUrl']),
        code() {
            return { tracker: `&lt;script defer src="${this.baseUrl}/client/v1/dreamroi.min.js"&gt;&lt;/script&gt;
&lt;script defer src="${this.baseUrl}/client/v1/platforms/shoptet.min.js"&gt;&lt;/script&gt;
&lt;script&gt;
  window.addEventListener('DOMContentLoaded', function() {
    dreamroi_initTracker('%id%');
  });
&lt;/script&gt;`
        
        }}
    }
}
</script>